import type { AuditLog } from "@wingspanhq/wingspan-api-sdk";

export type EventGroup =
  | {
      type: "single";
      event: AuditLog;
    }
  | {
      type: "grouped";
      events: AuditLog[];
      actor: string;
      eventTitle: string;
      anchorTimestamp: Date;
    };

export const GROUP_WINDOW_MS = 30 * 60 * 1000; // 30 minutes
